import React from 'react'
import PropTypes from 'prop-types'
import Svg from 'src/Components/shared/Svg'

const DollarSignSvg = ({ className }) => (
  <Svg
    className={className}
    width='29'
    height='52'
    viewBox='0 0 29 52'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M21.2212 23.7129C19.2283 22.6286 17.1094 21.8025 15.0115 20.9454C13.7948 20.4497 12.6304 19.8714 11.6025 19.0659C9.57802 17.4756 9.96613 14.8939 12.3367 13.8716C13.008 13.5825 13.7108 13.4895 14.4241 13.4482C17.1723 13.3036 19.7842 13.7993 22.2702 14.9766C23.5079 15.5652 23.917 15.3793 24.3366 14.1091C24.7771 12.7667 25.1443 11.4035 25.5534 10.0507C25.8261 9.14199 25.4904 8.54305 24.6198 8.16096C23.0254 7.46908 21.3891 6.9734 19.6688 6.7049C17.4241 6.36412 17.4241 6.3538 17.4136 4.13357C17.4031 1.00459 17.4031 1.00459 14.2143 1.00459C13.7528 1.00459 13.2913 0.994263 12.8297 1.00459C11.3402 1.0459 11.0885 1.30406 11.0465 2.78077C11.0256 3.44168 11.0465 4.10259 11.036 4.77382C11.0256 6.73588 11.0151 6.7049 9.10599 7.38646C4.49066 9.03873 1.63755 12.1367 1.33335 17.0935C1.06063 21.4823 3.38928 24.4461 7.05007 26.6044C9.30529 27.9365 11.8018 28.7213 14.1933 29.7643C15.1269 30.1671 16.0185 30.6318 16.7947 31.272C19.0919 33.1411 18.6723 36.2495 15.9451 37.4267C14.4871 38.0566 12.9451 38.2115 11.3612 38.0153C8.91719 37.7159 6.57805 37.0859 4.37528 35.9603C3.08508 35.2994 2.70746 35.475 2.26691 36.8484C1.88929 38.036 1.55363 39.2339 1.21797 40.4318C0.766927 42.0427 0.934758 42.4248 2.49768 43.1787C4.49066 44.1287 6.62001 44.6141 8.79131 44.9548C10.4906 45.2233 10.543 45.2956 10.564 47.0305C10.5745 47.8153 10.5745 48.6105 10.585 49.3953C10.5955 50.3867 11.078 50.965 12.1165 50.9856C13.2913 51.0063 14.4766 51.0063 15.6514 50.9753C16.6164 50.9546 17.1094 50.4383 17.1094 49.4779C17.1094 48.4039 17.1618 47.3196 17.1199 46.2457C17.0674 45.151 17.55 44.5934 18.6199 44.3043C21.0849 43.6434 23.1828 42.3422 24.7981 40.4008C29.2876 35.0309 27.5778 27.1723 21.2212 23.7129Z'
      stroke='#9D97A6'
      strokeWidth='1.5'
    />
  </Svg>
)

DollarSignSvg.propTypes = {
  className: PropTypes.string
}

export default DollarSignSvg
